import { Footer as BookendsFooter } from '@uds/bookends';
import { ReactRouterLink } from '@uds/react-router-adapter';
import { useExternalRoutes } from 'domain/selectors/common';

export default function Footer(): JSX.Element {
  const externalRoutes = useExternalRoutes();
  return <BookendsFooter LinkComponent={ReactRouterLink} externalRoutes={externalRoutes} />;
}
